import { MdClose, MdOutlineBlock } from 'react-icons/md'
import '../css/others/reason.css'
import { Button, Form, FormControl, FormGroup, FormLabel } from 'react-bootstrap'
import api from '../../api'
import { useNavigate } from 'react-router-dom'
import { useContext } from 'react'
import { Dimcontext } from '../../context/pagecontext'
import { ToastContainer } from 'react-toastify'

export const ReasonNl = ({set_reason, id, appno, showToast, showsToast, onclose, TitleCase}) => {
    const { setDim } = useContext(Dimcontext)
    const navigate = useNavigate()
    const handlerejectclose = () => {
        set_reason(false)
        setDim(false)
    }

    const handlerejectdoc = async(e) =>{
        e.preventDefault()
        let reason = document.getElementById('reason').value.trim().replace(/\s+/g, ' ')
        if(!/^[A-Za-z0-9 /.,&()-]+$/.test(reason)) return showToast("Text field invalid!..Only Numbers,letter & ()...")
        const data1 = {docstatus:"rejected", rejreason: reason}
        try{
            await api.patch(`/updateone_nl/${id}`,{data1})
            showsToast("Rejected")
            set_reason(false)
            setDim(false)
            onclose()
        } catch(error) {
            if ( error.response?.status === 401) {
                showToast("Unauthorized! Please login again.")
                localStorage.removeItem("token");
                navigate("/login");
            } else {
                console.log(error);
            }
        }
    }

  return (
    <div className="reasonbox">
        <ToastContainer/>
        <div>
            <h5 className='text-center'>{`Reason to Reject Nagal Application No. ${appno}`}</h5>
            <Form id='res' onSubmit={(e)=>handlerejectdoc(e)}>
                <FormGroup controlId='reason' style={{ fontSize:'15px'}} className='m-3 p-3'>
                    <FormLabel>Reason</FormLabel>
                    <FormControl 
                        type='text'   
                        required 
                        style={{fontSize:'15px'}}
                        placeholder='Enter Reason to Reject'
                        name='reason'
                    />
                </FormGroup>
            </Form>
        </div>
        <div className="d-flex justify-content-around">
            <Button onClick={handlerejectclose} className="btnc"> Close <MdClose/> </Button>
            <Button type='submit' form='res' className="btns"> Reject <MdOutlineBlock/> </Button>
        </div>
    </div>
  )
}
